import React from "react";
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS,LOCAL_PATHS } from "../../../Constants";
import ability from '../../config/defineAbility';
import {helpers} from '../../../helpers';

import { PERMS } from '../../config/perms'
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";

import CardBox from "../../../components/CardBox";
 
const PayrollDetails = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
 
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [year, setyear] = useState('')
  const [month, setmonth] = useState('')
const [showModal, setshowModal] = useState(false)
const [selected_payroll, setselected_payroll] = useState(null)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);
 
  useEffect(() => {
    fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setIsLoading(true);
 

    var json={
      "status": 10001,
      "message": "Your request was processed successfully.",
      "data": [
          {
              "id": "9feefe8f-686e-4f33-af7b-09b50b3b3bdb",
              "month": 9,
              "year": 2023,
              "details": {
                  "branch": "Nairobi",
                  "bonuses": [
                      {
                          "name": "Eid-ul-Fitrbonus",
                          "amount": 25
                      }
                  ],
                  "net_pay": 429.5,
                  "staff_id": "42360aaf-898f-4b83-96f5-8a6c2b827a0e",
                  "department": "ICT",
                  "hrs_worked": 0,
                  "staff_name": "Moses Njagua Njeri",
                  "designation": "Ebms Adminstrator",
                  "holiday_hrs": 0,
                  "total_bonus": 429.5,
                  "sick_leave_hrs": 0,
                  "annual_leave_hrs": 0
              }
          },
          {
              "id": "df18a6a2-653e-483d-9e02-546338b9598e",
              "month": 9,
              "year": 2023,
              "details": {
                  "branch": "Bardale",
                  "bonuses": [
                      {
                          "name": "Eid-ul-Fitrbonus",
                          "amount": 25
                      }
                  ],
                  "net_pay": 0,
                  "staff_id": "07e31644-1d1b-4a12-87ec-1e45791e285d",
                  "department": null,
                  "hrs_worked": 0,
                  "staff_name": "Abdullahi Mohamed Issa",
                  "designation": "CCCM Monitor",
                  "holiday_hrs": 0,
                  "total_bonus": 0,
                  "sick_leave_hrs": 0,
                  "annual_leave_hrs": 0
              }
          }
      ]
  };
    genericPost(ENDPOINTS.PAYROLL_DETAILS, {})
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        } else{
          alert(res.status )
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
 
  };
  const runPayroll =  (e) => {
    setIsLoading(true)
    e?.preventDefault();
   let data= {
      "payroll_id": selected_payroll?.id,
      "month":month,
      "year":year
  }
  
   
  console.clear();
  console.log(data);
  console.log(ENDPOINTS.INITIALIZE_PAYROLL)
  genericPost(ENDPOINTS.INITIALIZE_PAYROLL, data)
  .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
              history.push({
                  pathname: LOCAL_PATHS.PAYROLL_SELECTION,
                  state: {
                      payroll_info: response.data.data,
                      payroll_id:selected_payroll?.id,
                      month:month,
                      year:year
                  },
              });
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }
  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <h1> Payroll Details </h1>
 
       

<div className="row">
{/* <CardBox title={"PAYROLL NAME"} value={data.payroll_name} icon={"fa fa-money"}  ></CardBox>
<CardBox title={"MONTH / Year"} value={data.month +"/"+ data.year} icon={"fa fa-calendar"}  ></CardBox>
<CardBox title={"TOTAL EMPLOYEES"} value={data.payroll_name} icon={"fa fa-group"}  ></CardBox>
<CardBox title={"PAYROLL AMOUNT "} value={helpers.number_format(data.payroll_amount)} icon={"fa fa-dollar"}  ></CardBox>
  */}


<br/>
<br/>
</div>

        </div>
        <div className="col-md-10">
      
        </div>
      </div>
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Staff Name",
              field: "details.staff_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Designation",
              field: "details.designation",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Department",
              field: "details.department",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Holiday hrs",
              field: "details.holiday_hrs",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Hrs worked ",
              field: "details.hrs_worked",
              sortable: true,
              filter: true,
            }, {
              headerName: "Sick leave hrs ",
              field: "details.sick_leave_hrs",
              sortable: true,
              filter: true,
            }, {
              headerName: "Annual leave hrs ",
              field: "details.annual_leave_hrs",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Total Bonus ",
              field: "details.total_bonus",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Net Pay ",
              field: "details.net_pay",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Print Payslip ",
              field: "",
              sortable: true,
              filter: true,
              cellStyle: function (params) {
                return { color: "white", backgroundColor: "#FFF" };
              },
              cellRendererFramework: (e) => {
                return (
                  <div>
       {ability.can(PERMS.UPDATE, PERMS.UPDATE_SURVEYS) && (

                  <button
                  className="badge btn-primary"
                    onClick={() => {
                      history.push({
                        pathname: LOCAL_PATHS.PAYSLIP,
                        state: { data: { "staff_id":e.data.details.staff_id,
                        "month":e.data.month,
                        "year":e.data.year } },
                      });
                    }}
                  >
                   
                    
                    Print Payslip    &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>)}</div>

                );
              },
            },
          ]}
        ></AgGridReact>
      </div> 
   
    </div>



  );
};

export default PayrollDetails;
